import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpGet, httpPost, httpPut } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'

import r from 'reactotron-react-js'

const CHANGE_PR_REQUESTER = makeKeys('CHANGE_PR_REQUESTER')
const CANCEL_PR = makeKeys('CANCEL_PR')
const CANCEL_GR = makeKeys('CANCEL_GR')
const CANCEL_BILLING = makeKeys('CANCEL_BILLING')
const ADD_DUMMY_USER = makeKeys('ADD_DUMMY_USER')
const GET_VENDOR_USER_DETAIL = makeKeys('GET_VENDOR_USER_DETAIL')
const CHECK_VENDOR_CODE_FOR_ADD = makeKeys('CHECK_VENDOR_CODE_FOR_ADD')
const UPDATE_VENDOR_USER_COMPANIES = makeKeys('UPDATE_VENDOR_USER_COMPANIES')
const CLEAR_USER_DATA = 'CLEAR_USER_DATA'
const SET_VENDOR_USER_ACTIVE = makeKeys('SET_VENDOR_USER_ACTIVE')
const SET_VENDOR_USER_UNLOCK = makeKeys('SET_VENDOR_USER_UNLOCK')
const CANCEL_PR_AND_SAP = makeKeys('CANCEL_PR_AND_SAP')
const CHECK_GR_CONDITION_FOR_CANCEL = makeKeys('CHECK_GR_CONDITION_FOR_CANCEL')

export const changePrRequester = makeAction(CHANGE_PR_REQUESTER.REQUEST, 'data', 'onSuccess')
export const cancelPr = makeAction(CANCEL_PR.REQUEST, 'data', 'onSuccess')
export const cancelGr = makeAction(CANCEL_GR.REQUEST, 'data', 'onSuccess')
export const cancelBilling = makeAction(CANCEL_BILLING.REQUEST, 'data', 'onSuccess')
export const addDummyUser = makeAction(ADD_DUMMY_USER.REQUEST, 'data', 'onSuccess')
export const getVendorUserDetail = makeAction(GET_VENDOR_USER_DETAIL.REQUEST, 'email')
export const checkVendorCode = makeAction(CHECK_VENDOR_CODE_FOR_ADD.REQUEST, 'code', 'onSuccess')
export const updateVendorUserCompanies = makeAction(UPDATE_VENDOR_USER_COMPANIES.REQUEST, 'data', 'onSuccess')
export const clearUserData = makeAction(CLEAR_USER_DATA)
export const setVendorUserActive = makeAction(SET_VENDOR_USER_ACTIVE.REQUEST, 'id', 'active')
export const setVendorUserUnlock = makeAction(SET_VENDOR_USER_UNLOCK.REQUEST, 'id')
export const cancelPrAndSap = makeAction(CANCEL_PR_AND_SAP.REQUEST, 'data', 'onSuccess')
export const checkGRConditionForCancel = makeAction(CHECK_GR_CONDITION_FOR_CANCEL.REQUEST, 'data', 'onSuccess')

const getVendorUserDetailSuccess = makeAction(GET_VENDOR_USER_DETAIL.SUCCESS, 'data')
const updateVendorUserCompaniesSuccess = makeAction(UPDATE_VENDOR_USER_COMPANIES.SUCCESS)
const setVendorUserActiveSuccess = makeAction(SET_VENDOR_USER_ACTIVE.SUCCESS, 'active')
const setVendorUserUnlockSuccess = makeAction(SET_VENDOR_USER_UNLOCK.SUCCESS)
const checkGRConditionForCancelSuccess = makeAction(CHECK_GR_CONDITION_FOR_CANCEL.SUCCESS, 'data')

const supportPath = path => path ? urlWithPrefix(`support/${path}`) : urlWithPrefix('support')

function* changePrRequesterRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Changing PR Requester and Creator'))
    const response = yield httpPut(supportPath('changePrRequester'), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(toastSuccess('Change PR Requester and Creator Success.'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Change PR Requester and Creator Error!'))
    }
    yield put(appLoaded())
  }
}

function* cancelPrRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Submitting cancel PR data.'))
    const response = yield httpPut(supportPath('cancelPR'), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(toastSuccess('Cancel PR Success.'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Cancel PR Error!'))
    }
    yield put(appLoaded())
  }
}

function* cancelGrRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    let dataGR = {
      documentNumber: data.documentNumber,
      requester: data.requesterCancel,
      reason: data.reason,
      createdMatDocNo: data.createdMatDocNo,
      createdDocYear: data.createdDocYear,
      postingDate: data.postingDate
    }
    yield put(appLoading('Submitting cancel GR data.'))
    const response = yield httpPut(supportPath('cancelGR'), dataGR)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(toastSuccess('Cancel GR Success.'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Cancel GR Error!'))
    }
    yield put(appLoaded())
  }
}

function* cancelBillingRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Submitting cancel Billing data.'))
    const response = yield httpPut(supportPath('cancelBilling'), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(toastSuccess('Cancel Billing Success.'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Cancel billing Error!'))
    }
    yield put(appLoaded())
  }
}


function* addDummyUserRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Add dummy user.'))
    const response = yield httpPost(supportPath(`addDummyUser/${data.vendorCode}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(toastSuccess('Add dummy user success.'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Add dummy user error!'))
    }
    yield put(appLoaded())
  }
}

function* getVendorUserDetailRequest(action) {
  const { email } = action.payload
  try {
    yield put(appLoading('Get user data.'))
    const response = yield httpGet(supportPath('vendor/user'), { email })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getVendorUserDetailSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Get user data error!'))
    }
    yield put(appLoaded())
  }
}

function* updateVendorUserCompaniesRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Update vendor companies data.'))
    const response = yield httpPut(supportPath(`vendor/user/${data.id}`), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(toastSuccess(response.data.message))
        yield put(updateVendorUserCompaniesSuccess())
        onSuccess()
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update vendor companies data error!'))
    }
    yield put(appLoaded())
  }
}

function* checkVendorCodeRequest(action) {
  const { code, onSuccess } = action.payload
  try {
    yield put(appLoading('Validate vendor code.'))
    const response = yield httpGet(supportPath('vendor/validateCode'), { code })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess(response.data)
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Validate vendor code error!'))
    }
    yield put(appLoaded())
  }
}

function* setVendorUserActiveRequest(action) {
  const { id, active } = action.payload

  try {
    yield put(appLoading('Update vendor user status.'))
    const response = yield httpPut(supportPath(`vendor/user/${id}/${active ? 'active' : 'disable'}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(setVendorUserActiveSuccess(active))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update vendor user status error!'))
    }
    yield put(appLoaded())
  }
}

function* setVendorUserUnlockRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading('Update vendor user.'))
    const response = yield httpPut(supportPath(`vendor/user/${id}/unlock`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(setVendorUserUnlockSuccess())
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update vendor user status error!'))
    }
    yield put(appLoaded())
  }
}

function* cancelPrAndSapRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    let dataPR = {
      docNumber: data.documentNumber,
      requester: data.requesterCancel,
      reason: data.reason,
    }
    yield put(appLoading('Submitting cancel PR data.'))
    const response = yield httpPut(supportPath('cancelPRAndSAP'), dataPR)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(toastSuccess('Cancel PR Success.'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Cancel PR Error!'))
    }
    yield put(appLoaded())
  }
}

function* checkGRConditionForCancelRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    let dataGR = {
      docNumber: data.documentNumber,
      requester: data.requesterCancel,
      reason: data.reason
    }
    yield put(appLoading('Submitting cancel GR data.'))
    const response = yield httpPost(supportPath('checkCancelGR'), dataGR)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(checkGRConditionForCancelSuccess(response.data))
        onSuccess(response.data)
        // yield put(toastSuccess('Cancel GR Success.'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Cancel GR Error!'))
    }
    yield put(appLoaded())
  }
}

export function* watchSupportSaga() {
  yield takeLatest(CHANGE_PR_REQUESTER.REQUEST, changePrRequesterRequest)
  yield takeLatest(CANCEL_PR.REQUEST, cancelPrRequest)
  yield takeLatest(CANCEL_GR.REQUEST, cancelGrRequest)
  yield takeLatest(CANCEL_BILLING.REQUEST, cancelBillingRequest)
  yield takeLatest(ADD_DUMMY_USER.REQUEST, addDummyUserRequest)
  yield takeLatest(GET_VENDOR_USER_DETAIL.REQUEST, getVendorUserDetailRequest)
  yield takeLatest(CHECK_VENDOR_CODE_FOR_ADD.REQUEST, checkVendorCodeRequest)
  yield takeLatest(UPDATE_VENDOR_USER_COMPANIES.REQUEST, updateVendorUserCompaniesRequest)
  yield takeLatest(SET_VENDOR_USER_ACTIVE.REQUEST, setVendorUserActiveRequest)
  yield takeLatest(SET_VENDOR_USER_UNLOCK.REQUEST, setVendorUserUnlockRequest)
  yield takeLatest(CANCEL_PR_AND_SAP.REQUEST, cancelPrAndSapRequest)
  yield takeLatest(CHECK_GR_CONDITION_FOR_CANCEL.REQUEST, checkGRConditionForCancelRequest)
}

const initial = {
  userData: { data: {}, loading: false },
  checkGRCancelData: { data: {}, loading: false }
}

export default createReducer(initial, state => ({
  [GET_VENDOR_USER_DETAIL.REQUEST]: () => ({
    ...state,
    userData: { data: {}, loading: true }
  }),
  [GET_VENDOR_USER_DETAIL.SUCCESS]: (data) => ({
    ...state,
    userData: { data: data.data, loading: false }
  }),
  [UPDATE_VENDOR_USER_COMPANIES.SUCCESS]: () => ({
    ...state,
    userData: { data: {}, loading: false }
  }),
  [CLEAR_USER_DATA]: () => ({
    ...state,
    userData: { data: {}, loading: false }
  }),
  [SET_VENDOR_USER_ACTIVE.SUCCESS]: (data) => r.log({data}) || ({
    ...state,
    userData: {
      data: {
        ...state.userData.data,
        disable: !data.active
      },
      loading: false
    }
  }),
  [SET_VENDOR_USER_UNLOCK.SUCCESS]: () => ({
    ...state,
    userData: {
      data: {
        ...state.userData.data,
        isLocked: false
      },
      loading: false
    }
  }),
  [CHECK_GR_CONDITION_FOR_CANCEL.REQUEST]: () => ({
    ...state,
    checkGRCancelData: { data: {}, loading: true }
  }),
  [CHECK_GR_CONDITION_FOR_CANCEL.SUCCESS]: (data) => ({
    ...state,
    checkGRCancelData: { data: data.data, loading: false }
  }),
}))